module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_20-5afd45fd362317743c90466034e134d0.jpg";